<!--
    职鉴跳板页
    包含：职鉴考卷、职鉴走图
-->
<template>
    <div class="fiscan-paper-index">
        <div v-if="isTrack">
            <fiscan-track
                ref="fiscanTrack"
                :value="value"
                v-bind="$props"
                @close="close"
                @review="reviewTrackPaper"
            />
        </div>

        <div v-else>
            <fiscan-paper
                ref="fiscanPaper"
                :value="value"
                v-bind="$props"
                @close="close"
            />
        </div>
    </div>
</template>

<script>
import {screenfull} from "@/utils";
import FiscanPaper from "./FiscanPaper";
import FiscanTrack from "./FiscanTrack";

export default {
    components: {
        FiscanPaper,
        FiscanTrack
    },

    props: {
        isTrack: {
            type: Boolean,
            default: false
        },
        // v-model
        value: {
            type: Boolean,
            default: false
        },
        // 接口返回的试卷数据
        data: {
            type: Object,
            required: true
        },
        /**
         *  用途 {Number}
         *  考卷作答：1
         *  考卷查看：2
         */
        usage: {
            type: Number,
            required: true
        },
        /**
         * 试卷类型 {String}
         * 考试：exam
         * 模拟考试：mockExam
         * 练习：practice
         * 预览：preview
         **/
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {

        }
    },

    watch: {
        value(visible) {
            // 打开后自动全屏
            this.$nextTick(() => {
                if (visible && !screenfull.isFull()) {
                    // const domId = this.isTrack ? 'fiscan-track': 'fiscan-paper'
                    // screenfull.request(document.getElementById(domId))
                    screenfull.request()
                }
            })
        }
    },

    methods: {
        reviewTrackPaper(paperID) {
            this.isTrack = false
            this.$nextTick(() => {
                this.$refs.fiscanPaper.reviewPaper(paperID)
            })
        },
        close() {
            this.$emit('input', false)
            this.$emit('close')
        }
    },
}
</script>
